module.exports = __webpack_public_path__ + "static/media/MenuDropDownClose.b46ecc70.svg";